import { z } from "zod";

/**
 * Base schema for all Firestore documents.
 * Every document read from Firestore includes its document ID as `id`.
 */
export const DocumentSchema = z.object({
  id: z.string(),
});

export type FirestoreDoc = z.infer<typeof DocumentSchema>;
